export enum TypeKeys {
  LOGIN = 'authentication/LOGIN',
  LOGIN_SUCCESSFUL = 'authentication/LOGIN_SUCCESSFUL',
  LOGIN_UNSUCCESSFUL = 'authentication/LOGIN_UNSUCCESSFUL',
  LOGIN_ERROR = 'authentication/LOGIN_ERROR',
  LOGOUT = 'authentication/LOGOUT',
  LOGOUT_SUCCESSFUL = 'authentication/LOGOUT_SUCCESSFUL',
}
